document.addEventListener('DOMContentLoaded', function() {
  var logo = document.querySelector('.header__heading-logo');
  if (!logo) return;
  
  var path = window.location.pathname;

  if (path.includes('/collections/af-baby') || path.includes('/pages/af-baby')) {
    swapLogo(logo, 'https://cdn.shopify.com/s/files/1/0739/2038/1228/files/logo-af-_baby.png?v=1769629337', 'AF Baby');
  } else if (path.includes('/collections/af-little-kids') || path.includes('/collections/af-littles')) {
    swapLogo(logo, 'https://cdn.shopify.com/s/files/1/0739/2038/1228/files/logo-af-littles.png?v=1769629337', 'AF Littles');
  } else if (path.includes('/collections/af-youth')) {
    swapLogo(logo, 'https://cdn.shopify.com/s/files/1/0739/2038/1228/files/logo-af-youth.png?v=1769641030', 'AF Youth');
  } else if (path.includes('/collections/af-kids') || path.includes('/pages/af-kids')) {
    swapLogo(logo, 'https://cdn.shopify.com/s/files/1/0739/2038/1228/files/logo-af-kids.png?v=1769641097', 'AF Kids');
  }
});

function swapLogo(logo, url, altText) {
  logo.srcset = '';
  logo.src = url;
  logo.alt = altText;
  logo.style.width = '180px';
  hidePageTitle();
}

function hidePageTitle() {
  var titles = document.querySelectorAll('.collection-hero__title, h1.collection__title, .collection h1, h1.title, .page-title, h1.page-header__title, .template-page h1, main h1:first-of-type');
  titles.forEach(function(title) {
    title.style.display = 'none';
  });
}